export var TransferProcessorsEnum;
(function (TransferProcessorsEnum) {
    TransferProcessorsEnum["PSE"] = "Pse Processor";
    TransferProcessorsEnum["ETPay"] = "ETPay Processor";
    TransferProcessorsEnum["ETPayPlus"] = "ETPayPlus Processor";
    TransferProcessorsEnum["ACCENDO"] = "Accendo Processor";
    TransferProcessorsEnum["STP"] = "STP Processor";
})(TransferProcessorsEnum || (TransferProcessorsEnum = {}));
